import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import BulkRegister from "./page/BulkRegister";
import { SuperAdminStatusEnum } from '../../../../props/enum';

const BulkRegistration: React.FC = () => {
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_BULK_REGISTRATION));
  if (isPermitted)
    return (
      <>
        <BulkRegister />
      </>
    );
  return (
    <div className="text-primary-400 text-center h-[60vh] flex justify-center items-center">
      You don't have the permission.
    </div>
  );
};
export default BulkRegistration;
